import { render } from "./FlowItemDetails.vue?vue&type=template&id=3c49e914"
import script from "./FlowItemDetails.vue?vue&type=script&lang=js"
export * from "./FlowItemDetails.vue?vue&type=script&lang=js"

import "./FlowItemDetails.vue?vue&type=style&index=0&id=3c49e914&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
